<template>
  <div class="Sidebar--Discount Discount">
    <form class="Discount--Form" v-if="show_seller_code_form">
      <el-form ref="form"
        @submit.prevent="ApplySellerCode(sellerCode)"
      >
        <el-form-item
          :label="AppConfig.translations.seller_code_form.type_code"
          class="Discount--Input"
        >
          <el-input placeholder v-model="sellerCode" class="input-with-select"
            :class="{ 'Discount--Busy': isDiscountOperationRunning }"
            v-on:keyup.enter="ApplySellerCode(sellerCode)"
          >
            <el-button
              slot="append"
              type="info"
              @click="ApplySellerCode(sellerCode)"
              :loading="CheckoutStatus.SellerCode.add === 'LOADING'"
              :disabled="isDiscountOperationRunning"
            >Aplicar</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </form>
    <div
      class="Discount__Content"
      v-if="sellerCodeApplied"
    >
      <h6>
        <b>Código aplicado:</b>
      </h6>
      <div v-loading="CheckoutStatus.SellerCode.delete === 'LOADING'" class="Discount__List">
        <el-tag
          closable
          size="small"
          :disable-transitions="false"
          @close="removeSellerCode(sellerCodeApplied)"
        >{{sellerCodeApplied}}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import { mapFilters } from '@/helpers/filters'
import { SELLER_CODE_ATTRIBUTE, saveSellerCode, clearSellerCode } from '@/services/sellerCodeStorage'

export default {
  name: 'SellerCodeForm',
  components: {},
  data () {
    return {
      sellerCode: '',
      loading: false
    }
  },
  props: ['products'],
  computed: {
    ...mapGetters(['AppConfig', 'Checkout', 'CheckoutStatus', 'CustomAttributes']),
    sellerCodeApplied () {
      const sellerCodeAttribute = (this.Checkout.note_attributes || [])
        .find(attribute => attribute.name === SELLER_CODE_ATTRIBUTE)
      return sellerCodeAttribute ? sellerCodeAttribute.value : ''
    },
    isDiscountOperationRunning () {
      return this.CheckoutStatus.DiscountCode.add === 'LOADING' ||
        this.CheckoutStatus.Promotions.get === 'LOADING'
    },
    show_seller_code_form () {
      if (
        sessionStorage.getItem('show_seller_code_form')
      ) {
        // sessionStorage.removeItem('show_seller_code_form')
        return true
      }
      if (
        this.AppConfig.components.general &&
        this.AppConfig.components.general.seller_code_form
      ) {
        return !!this.AppConfig.components.general.seller_code_form.show_seller_code_form
      }
      return true
    }

  },
  methods: {
    ...mapActions([
      'UpdateCheckoutState',
      'ApplyDiscountCode',
      'ApplyGiftCard',
      'RemoveGiftCard',
      'RemoveDiscountCode',
      'DeleteDiscount',
      'DeleteAddition',
      'SetCustomAttribute',
      'SendCustomAttributes',
      'DeleteCustomAttribute',
      'setCheckoutStatus'
    ]),
    ...mapFilters(['formatMoney']),
    async ApplySellerCode (sellerCode) {
      if (this.isDiscountOperationRunning || !this.hasCode(sellerCode)) return
      const trimmedSellerCode = sellerCode.trim()
      this.setSellerCodeAddStatus('LOADING')
      try {
        await this.SetCustomAttribute([SELLER_CODE_ATTRIBUTE, trimmedSellerCode])
        await this.SendCustomAttributes()
        saveSellerCode(this.Checkout.id, trimmedSellerCode)
      } finally {
        this.setSellerCodeAddStatus('IDLE')
      }
    },
    async removeSellerCode (sellerCode) {
      if (!this.hasCode(sellerCode)) return
      await this.DeleteCustomAttribute(SELLER_CODE_ATTRIBUTE)
      if (!this.sellerCodeApplied) {
        clearSellerCode()
        this.sellerCode = ''
      }
    },
    setSellerCodeAddStatus (status) {
      this.setCheckoutStatus({
        SellerCode: {
          ...this.CheckoutStatus.SellerCode,
          add: status
        }
      })
    },
    hasCode (code) {
      if (!code) return false
      return code.trim().length > 1
    }
  }
}
</script>
